// SPDX-License-Identifier: AGPL-3.0-or-later

import {reloadForInterests} from '@app/features/feed/commands/FeedCommands';
import {Logger} from '@app/features/platform/utils/AppLogger';
import UserSettings from '@app/features/user/state/UserSettings';
import Users from '@app/features/user/state/Users';

const logger = new Logger('FeedInterestCommands');

// Micup akis-v3: replaces the user's feed interests; an empty set is the skip, and either way the server records the
// answer (feed_interests_answered_at). Discover and Reels load again from the top when the set changed.
export async function saveFeedInterests(categoryIds: ReadonlyArray<string>): Promise<boolean> {
	const before = UserSettings.feedInterestCategoryIds.join(',');
	const accountId = Users.currentUser?.id;
	const epoch = UserSettings.getAccountEpoch();
	try {
		const response = await UserSettings.saveSettings({feedInterestCategoryIds: [...categoryIds]});
		// The answer of an account switched away while it saved stays off the next account.
		if (Users.currentUser?.id !== accountId || UserSettings.getAccountEpoch() !== epoch) return false;
		UserSettings.updateUserSettings(response, {
			hydrate: false,
			fields: ['feedInterestCategoryIds', 'feedInterestsAnsweredAt'],
		});
	} catch (error) {
		logger.warn('Failed to save feed interests:', error);
		return false;
	}
	if (UserSettings.feedInterestCategoryIds.join(',') !== before) void reloadForInterests();
	return true;
}
